module.exports = __webpack_public_path__ + "static/img/ic_transport@2x.35b8eed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_transport@2x.png
// module id = gKN7
// module chunks = 1